import type { ReactNode } from "react";

/** The navy brand half plus the white form half shared by the sign-in and sign-up windows. */
export function AuthCard({ children }: { children: ReactNode }) {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="/brand/brand_logo_white.png" alt="" />
          <div className="product">Model Bench</div>
          <div className="tagline">Image annotation &amp; model training</div>
        </div>
        <div className="auth-form">{children}</div>
      </div>
    </div>
  );
}
